// extracted by mini-css-extract-plugin
export var body = "_2w-1";
export var bodyPadded = "_2w-2";
export var chevron = "_2w-4";
export var chevronOpen = "_2w-5";
export var header = "_2w-0";
export var icon = "_2w-3";